/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
import Modal from '@carvana/modal';
import { ThemeProvider } from '@carvana/theme';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  CloseButton,
  NoCloseButton,
  Header,
  ModalLoadingSpinner
} from './dashboard-modal.styles';
import { CloseModal } from './ducks/actions';
import { Initialize } from './ducks/reducer';

const renderModalChildren = (ModalChildren, defaultProps) => {
  if (!ModalChildren || !/function|object/.test(typeof ModalChildren))
    return null;

  return typeof (ModalChildren?.WrappedComponent || ModalChildren) ===
    'function' ? (
    <ModalChildren {...defaultProps} />
  ) : (
    React.cloneElement(ModalChildren, defaultProps)
  );
};

const DashboardModal = ({ registry }) => {
  const {
    ModalChildren,
    modalStyles,
    headerText,
    isFullscreenOnMobile,
    modalIsLoading,
    modalIsOpen,
    closeModalCallback,
    modalProps,
    noCloseButton,
    disableBackdropClick
  } = useSelector(state => state.dashboardModal) || {};

  const [hasInitialized, setHasInitialized] = useState(false);

  const closeModal = payload => {
    closeModalCallback(payload);
    CloseModal(payload);
  };

  useEffect(() => {
    if (registry) Initialize(registry);
    setHasInitialized(true);
  }, []);

  if (!hasInitialized) return <></>;

  return (
    <ThemeProvider>
      <Modal
        className={modalIsLoading && 'loading'}
        CloseButton={noCloseButton ? NoCloseButton : CloseButton}
        disableBackdropClick={disableBackdropClick}
        Content={modalStyles}
        fullscreenOnMobile={isFullscreenOnMobile}
        Header={Header}
        headerText={headerText}
        open={modalIsOpen}
        toggleModal={() => {
          closeModal(false);
        }}
        {...modalProps}
      >
        {modalIsLoading && (
          <ModalLoadingSpinner className={modalIsLoading && 'show'} />
        )}

        {renderModalChildren(ModalChildren, {
          closeModal,
          closeModalCallback,
          modalProps
        })}
      </Modal>
    </ThemeProvider>
  );
};

DashboardModal.propTypes = {
  registry: PropTypes.shape({})
};

DashboardModal.defaultProps = {
  registry: null
};

export default DashboardModal;
